module.exports = __webpack_public_path__ + "static/media/C_F02.44899328.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/C_F02.png
// module id = 73
// module chunks = 0